import ColumnTypes from '@/utils/ColumnTypes';
function getColums(that) {
	let arr = [
		{
			key: 'file_name',
			type: ColumnTypes.TextCell,
			label: '文件名称',
			minWidth: '200',
		},
		{
			key: 'add_time',
			type: ColumnTypes.TextCell,
			label: '操作时间',
			minWidth: '250',
		},
		{
			key: '',
			type: () => import('./tableCells/ImportSituationCell.vue'),
			label: '导入情况',
			minWidth: '250',
		},
        {
			key: '',
			type: () => import('./tableCells/statusCell.vue'),
			label: '状态',
			minWidth: '250',
		},
        {
			key: '',
			type: () => import('./tableCells/linkCell.vue'),
			label: '操作',
			width: '150',
		},
	];
	return arr;
}
export default getColums;